import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { CompletedTours } from 'components/ProductTour/Types'
import { UseQueryOptions, useQuery } from 'react-query'

export const fetchUserCompletedProductTours = async () => {
  const res = await sendToApi<CompletedTours>(`/user_completed_product_tours`)
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data
}

export const useUserCompletedProductTours = (options?: UseQueryOptions<CompletedTours>) => {
  return useQuery<CompletedTours>(['user_completed_product_tours'], () => fetchUserCompletedProductTours(), {
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    staleTime: Infinity,
    ...options,
  })
}
